<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2970"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2974"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2984"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2982" /></clipPath></defs><g
     id="g2976"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2978"><g
         id="g2980"
         clip-path="url(#clipPath2984)"><g
           id="g2986"
           transform="translate(277.2402,12.3501)"><path
             d="m 0,0 c -8.48,-3.14 -17.641,-4.85 -27.2,-4.85 h -148.16 c -43.37,0 -78.531,35.16 -78.531,78.53 v 192.74 c 0,43.37 35.161,78.53 78.531,78.53 H -27.2 c 43.37,0 78.53,-35.16 78.53,-78.53 V 131.28"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2988" /></g><g
           id="g2990"
           transform="translate(276.2891,357.2974)"><path
             d="m 0,0 h -200.664 c -11.078,0 -20.06,8.981 -20.06,20.061 0,11.079 8.982,20.06 20.06,20.06 L 0,40.121 c 11.079,0 20.06,-8.981 20.06,-20.06 C 20.06,8.981 11.079,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2992" /></g><g
           id="g2994"
           transform="translate(72.1797,431.2202)"><path
             d="m 0,0 v -33.8 h 207.551 v 76.65 c 0,16.8 -13.62,30.43 -30.431,30.43 H 30.431 C 13.63,73.28 0,59.65 0,42.85 V 30"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2996" /></g><g
           id="g2998"
           transform="translate(246.8447,89.501)"><path
             d="m 0,0 h -141.775 c -16.517,0 -29.907,13.39 -29.907,29.906 v 126.766 c 0,16.517 13.39,29.907 29.907,29.907 H 0 c 16.517,0 29.906,-13.39 29.906,-29.907 V 29.906 C 29.906,13.39 16.517,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3000" /></g><g
           id="g3002"
           transform="translate(224.085,206.2402)"><path
             d="m 0,0 h -24.678 v 24.678 c 0,8.973 -7.274,16.248 -16.248,16.248 H -55.33 c -8.974,0 -16.248,-7.275 -16.248,-16.248 V 0 h -24.678 c -8.973,0 -16.248,-7.274 -16.248,-16.248 v -14.404 c 0,-8.973 7.275,-16.248 16.248,-16.248 h 24.678 v -24.678 c 0,-8.973 7.274,-16.248 16.248,-16.248 h 14.404 c 8.974,0 16.248,7.275 16.248,16.248 V -46.9 H 0 c 8.974,0 16.248,7.275 16.248,16.248 v 14.404 C 16.248,-7.274 8.974,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3004" /></g><g
           id="g3006"
           transform="translate(102.8496,474.0703)"><path
             d="M 0,0 V -55.697"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3008" /></g><g
           id="g3010"
           transform="translate(149.3477,474.0703)"><path
             d="M 0,0 V -55.697"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3012" /></g><g
           id="g3014"
           transform="translate(202.5664,474.0703)"><path
             d="M 0,0 V -55.697"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3016" /></g><g
           id="g3018"
           transform="translate(249.0645,474.0703)"><path
             d="M 0,0 V -55.697"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3020" /></g><g
           id="g3022"
           transform="translate(324.9102,109.71)"><path
             d="m 0,0 c -0.91,3.87 -1.37,7.83 -1.37,11.79 0,13.08 4.99,26.16 14.97,36.14 19.96,19.96 52.31,19.96 72.27,0 l 62.9,-62.9 c 0.52,-0.52 1.02,-1.04 1.5,-1.58"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3024" /></g><g
           id="g3026"
           transform="translate(488.0195,66.5898)"><path
             d="m 0,0 c 0.421,-2.64 0.631,-5.31 0.631,-7.98 0,-13.08 -4.99,-26.16 -14.971,-36.14 -16.51,-16.51 -41.51,-19.36 -60.949,-8.55"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3028" /></g><g
           id="g3030"
           transform="translate(442.2305,126.1899)"><path
             d="M 0,0 -25.421,-25.42"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3032" /></g><g
           id="g3034"
           transform="translate(387.9404,109.7095)"><path
             d="m 0,0 h -88.953 c -28.224,0 -51.105,-22.88 -51.105,-51.105 0,-28.224 22.881,-51.104 51.105,-51.104 H 0 c 28.225,0 51.104,22.88 51.104,51.104 C 51.104,-22.88 28.225,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3036" /></g><g
           id="g3038"
           transform="translate(343.4639,7.5)"><path
             d="M 0,0 V 102.209"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3040" /></g></g></g></g></svg>
</template>
